/**
* 头部菜单
*/ 
<template>
  <div class="footer">
    <div class="footer-top">
      <div class="synopsis">
        <img class="logo" src="../assets/img/logo1.png" />
        <!-- <div class="text">
          <p>文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字文字</p>
        </div> -->
      </div>
      <div class="footer-right">
        <div class="footer-list">
          <ul>
            <li style="color: black; font-size: 14px;font-weight: 600;">人才培训</li>
            <li><router-link class="router_title" to="/index/exam">考试报名</router-link></li>
            <li><router-link class="router_title" to="/index/classroom">课程报名</router-link></li>
            <li><router-link class="router_title" to="/index/live">最新直播</router-link></li>
            <li><router-link class="router_title" to="/certificate/certificate">证书申请</router-link></li>
          </ul>
          <ul style="margin: 0;">
            <li style="color: black;font-size: 14px;font-weight: 600;">帮助与反馈</li>
            <li><router-link class="router_title" to="/index/support?id=2">使用指南</router-link></li>
            <li><router-link class="router_title" to="/index/support?id=1">常见问题</router-link></li>
            <li @click="dialogFormVisible = true"><router-link class="router_title" to="" >意见反馈</router-link></li>
             <li> <a class="router_title" href="https://www.vastdata.com.cn/" target="_blank">海量数据官网</a></li>
          </ul>
        </div>
        <div class="contact-information">
          <div class="code">
            <ul>
              <li>
                <img :src="info.wxQrCode">
                <p>官方微信</p>
              </li>
              <li>
                <img :src="info.wxHelperQrCode">
                <p>微信小助手</p>
              </li>
            </ul>
          </div>
          <div>
            <div class="phone">
              <img src="../assets/img/icon14.png" alt="">
              <p>{{ info.contact }}</p>
            </div>
            <div class="address">
              <img src="../assets/img/icon15.png" alt="">
              <p>{{info.address}}</p>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <div class="footer-bottom">
      <a href="https://beian.miit.gov.cn/#/Integrated/index">
        <p class="filings">{{info.copyRight}}</p>
      </a>
      
      <ul>
        <!-- <li @click="commonText('flsm')">法律声明</li>
        <li>|</li> -->
        <li @click="commonText('yszc')">隐私保护</li>
        <li>|</li>
        <li @click="qywl">技术支持:牵亿网讯</li>
      </ul>
    </div>

    <div class="popup">
      <!-- 意见反馈 -->
      <el-dialog title="" :visible.sync="dialogFormVisible">
        <p class="popup-title">意见反馈</p>
        <div class="popup-form">
          <el-form label-position="top" label-width="80px" :model="userInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="userInfo.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="userInfo.email" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="phone">
              <el-input v-model="userInfo.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="您的意见和反馈：" prop="content">
              <el-input type="textarea" v-model="userInfo.content" placeholder="请输入您的意见和反馈"></el-input>
            </el-form-item>
            <el-form-item label="图片上传:" >
              <el-upload
                :action="uploadApi"
                list-type="picture-card"
                :on-remove="handleRemove"
                :on-success="handSuccess"
                :limit="3"
                name='image'
                >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button style="background-color: #ff821c;" size="small" type="warning" :loading="loading" @click="submitForm('ruleForm')">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { homeInfo,Feedback } from '../api/userMG'
export default {
  name: 'footers',
  data() {
    return {
      info:{},
      dialogFormVisible:false,
      userInfo:{
          name:'',
          email:'',
          phone:'',
          content:'',
          image:''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入反馈意见', trigger: 'blur' }
        ]
      },
      loading:false
    }
  },
  computed: {
    uploadApi() {
      return this.$store.getters.uploadApi;
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'));
    this.getHome();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Feedback(this.userInfo).then(res => {
            console.log("反馈意见",res)
            this.$message({
              message: '反馈成功',
              type: 'warning',
              offset:100
            })
            this.dialogFormVisible = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    commonText(code){
      this.$router.push({path:'/login/text',query: { code: code }})
    },
    async getHome(){
      await homeInfo().then(res => {
        this.info = res.data
      })
      .catch(err => {
        
      })
    },
    qywl(){
      window.open('https://www.bj1000e.com/')
    },
    handSuccess(response, file, fileList) {
      let list = [];
      fileList.forEach((item,i) => {
        list.push(item.response.data)
      })
      this.userInfo.image = list.join();
      console.log(this.userInfo.image)
    },
    handleRemove(file, fileList){
      let list = [];
      fileList.forEach((item,i) => {
        list.push(item.response.data)
      })
      this.userInfo.image = list.join();
      console.log(this.userInfo.image)
    }
  }
}
</script>
<style scoped>
  @media (min-width: 1366px) {
    .footer {
      width: 1280px;
    }
  }
  @media (min-width: 1600px) {
    .footer {
      width: 1500px;
    }
  }
  .footer{
    margin: auto;
  }
  .footer-top{
    padding: 90px 0 30px;
    display: flex;
    border-bottom: solid 1px #e6e6e6;
  }
  .synopsis{
    width: 50%;
  }
  .logo{
    width: 300px;
  }
  .text{
    width: 60%;
  }
  .text p{
    font-size: 13px;
  }
  .footer-right{
    
    display: flex;
    flex: 1;
    justify-content: space-between;
  }
  .footer-list{
    display: flex;
  }
  .footer-list ul{
    margin-right: 120px;
  }
  .footer-list ul li{
    font-size: 12px;
    padding: 10px 0;
    color: #999;
    cursor: pointer;
  }
  .footer-list ul li .router_title:hover{
    color: #ff821c;
  }
  .contact-information{
    flex: 1;
  }
  .code{
    margin-bottom: 40px;
  }
  .code ul{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .code ul li{
    background: #fff;
    padding: 8px;
    border-radius: 6px;
    margin-left:12px ;
  }
  .code ul li img{
    width: 80px;
    height: 80px;
    margin-bottom: 4px;
  }
  .code ul li p{
    text-align: center;
    font-size: 12px;
    margin-bottom: 4px;
  }
  .phone, .address{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  .phone img{
    width: 24px;
    margin-right: 14px;
  }
  .phone p{
    font-size: 28px;
    color: orange;
  }
  .address img{
    width: 13px;
    margin-right: 10px;
  }
  .address p{
    font-size: 12px;
  }
  .footer-bottom{
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .filings{
    font-size: 12px;
    color: #999;
  }
  .footer-bottom ul{
    display: flex;
    align-items: center;
  } 
  .footer-bottom ul li{
    font-size: 12px;
    color: #999;
    margin-left: 10px;
    cursor: pointer;
  }
  a{
    text-decoration:none
  }
  .router_title{
    color: #999;
  }

  .popup /deep/ .el-dialog__header, .popup /deep/ .el-dialog__body{
    padding: 0;
  }
  .popup /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 19px;
  }
  .popup /deep/ .el-dialog{
    border-radius: 8px;
  }
  .popup /deep/ .el-form-item__label{
    color: #000;
    font-weight: 600;
  }
  .popup-title{
    background: #ff821e;
    color: #fff;
    font-size: 16px;
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .popup-form{
    padding: 40px 110px;
  }
  .el-button--small{
    padding: 10px 80px;
  }
  .popup-form ul{
    display: flex;
    align-items:center;
    justify-content: space-between;
    margin-bottom: 20px;
  }


</style>


// WEBPACK FOOTER //
// src/components/footers.vue